<h1 matDialogTitle>Confirmar</h1>
<div mat-dialog-content [innerHtml]="confirmMessage"></div>
<div mat-dialog-actions class="pt-24 pb-16">
    <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(true)">Confirmar</button>
    <button mat-button (click)="dialogRef.close(false)">Cancelar</button>
</div>
